export default {
  '信息': '信息',
  '密码': '密码',
  '头像': '头像',

  '我的信息': '我的信息',

  '昵称': '昵称',
  '邮箱': '邮箱',
  '简介': '简介',
  '昵称不能为空': '昵称不能为空',
  '邮箱不能为空': '邮箱不能为空',
  '信息更新成功': '信息更新成功',

  '修改头像注意': '修改头像注意',
  '选择头像提交后将会自动提交修改头像为选择头像': '选择头像提交后将会自动提交修改头像为选择头像',
  '选择头像': '选择头像',
  '更新头像成功': '更新头像成功',

  '旧密码': '旧密码',
  '新密码': '新密码',
  '确认新密码': '确认新密码',
  '旧密码不能为空': '旧密码不能为空',
  '新密码不能为空': '新密码不能为空',
  '确认密码不能为空': '确认密码不能为空',
  '密码更新成功': '密码更新成功'
}
